import { readonly } from 'vue'
import { useState } from '#app/composables/state'
import type { PageType } from '~/types/tracking'

export type PageState = {
  type: PageType
  typeId: string
  login_origin?: string
  searchResults: Record<string, string>
}

export function usePageState() {
  const state = useState<PageState>('page-type-state', () => ({
    type: '',
    typeId: '',
    searchResults: {},
  }))

  const setPageState = (key: keyof PageState, value: string) => {
    state.value[key] = value
  }

  const setSearchTermItem = (path: string, value: string) => {
    state.value.searchResults[path] = value
  }

  const removeSearchResult = (key: string) => {
    state.value.searchResults = Object.fromEntries(
      Object.entries(state.value.searchResults).filter(([k]) => k !== key),
    )
  }

  const pageState = readonly(state)

  return {
    removeSearchResult,
    setSearchTermItem,
    setPageState,
    pageState,
  }
}
